export const RESPONSIVE_TOOLBAR = 'nav:responsiveToolbar';
export const BUSINESS_UNITS_RENAME_GATE = 'MultiAccount:BusinessUnitsRename';
export const PLPO_GATE = 'ProductLedProOnboardingUnboxingFlow:SpringSpotlight';
export const USER_INVITE_MODAL_GATE = 'UserSetup:UserInviteModal';
export const CALLING_REDESIGN_GATE = 'Calling:Rep:Redesign';
export const CALLING_REMOTE_DRAG_AND_DROP_GATE = 'Calling:RemoteDragAndDrop';
export const GH_TOUR_GATE = 'nav:gh:nav-gh-onboarding-tour';